import React from 'react';

const TermsAndConditions = () => {
  return (
    <div className="tandc-container">
      <h3>
        License Agreement for Non-Commercial Research Activities (hereinafter
        "Agreement")
      </h3>

      <p>
        The MERLIN Web Application is developed by and on behalf of the
        Management Information Systems Research Group of the Faculty of Economic
        and Business of the KU Leuven and is owned by the Katholieke
        Universiteit Leuven (hereinafter referred to as "KU LEUVEN").
      </p>

      <h4>Article 1 - Definitions</h4>

      <p>
        1.1 "MERLIN Web Application" shall mean the KU LEUVEN web application as
        made available to you on {document.location.hostname} during the term of
        this Agreement.
      </p>
      <p>
        1.2 "Effective Date" shall mean the date on which you start using the
        MERLIN Web Application.
      </p>
      <p>
        1.3 "Non-commercial User" shall mean a person using the MERLIN Web
        Application for non-commercial purposes on its own behalf or on behalf
        of a legal entity.
      </p>

      <h4>Article 2 - License</h4>

      <p>
        2.1 As long as you qualify as an Non-commercial User, KU LEUVEN hereby
        grants you a free of charge, non-exclusive, non-transferable license to
        use the MERLIN Web Application for strictly internal, non-commercial
        research use only.{' '}
      </p>
      <p>
        2.2 You acknowledge and agree that you may not use the MERLIN Web
        Application for non-research and/or commercial purposes without first
        obtaining an appropriate license from KU LEUVEN. For the purposes of
        this Agreement "use for commercial purposes" shall include the use or
        transfer of the MERLIN Web Application for a consideration as well as
        the use of the MERLIN Web Application to support commercial activities
        including providing services about the MERLIN Web Application to third
        parties or offering services to third Parties directly based on or
        relating to the MERLIN Web Application. Any use of the MERLIN Web
        Application for commercial purposes shall be deemed a breach of this
        Agreement for which KU LEUVEN shall be entitled to whatever remedies it
        may have under law or equity, including recovery of any damages.
      </p>
      <p>
        2.3 You shall not sublicense any of your rights to the MERLIN Web
        Application. Neither will you transfer the MERLIN Web Application to a
        third party, unless prior written agreement of KU LEUVEN has been
        obtained. Furthermore, you are not allowed to reverse engineer,
        decompile or disassemble the MERLIN Web Application.{' '}
      </p>

      <h4>Article 3 - Ownership</h4>

      <p>
        The MERLIN Web Application is copyrighted and KU LEUVEN retains all
        title and ownership to the MERLIN Web Application. Nothing in this
        Agreement shall preclude KU LEUVEN from entering into agreements with
        third parties concerning the MERLIN Web Application.
      </p>

      <h4>Article 4 - Feedback</h4>

      <p>
        You are encouraged to provide KU LEUVEN with feedback on the MERLIN Web
        Application as used in compliance with the Purpose. KU LEUVEN is
        permitted to use any information provided by you for any purpose
        including but not limited to changes to the MERLIN Web Application or
        for further research purposes. All feedback shall be sent to:
        MERLIN@KULEUVEN.BE.
      </p>

      <h4>Article 5 - Publication</h4>

      <p>
        Non-commercial User shall acknowledge KU LEUVEN as the owner of the
        MERLIN Web Application and shall include a reference to KU LEUVEN in any
        manuscript describing data obtained using the MERLIN Web Application.
      </p>

      <h4>Article 6 - No Support</h4>

      <p>
        This license does not entitle you to receive from KU LEUVEN technical
        support, telephone assistance, or enhancements or updates to the MERLIN
        Web Application. Any support that may be given by KU LEUVEN on voluntary
        basis is provided "as is" and KU LEUVEN makes no representations or
        warranties of any type whatsoever, express or implied, regarding the
        provided support.
      </p>

      <h4>Article 7 – Personal Data</h4>

      <p>
        KU LEUVEN shall process, as data controller, your personal data in order
        to be able to provide you with the software and in order to improve the
        software based on your user experience, to provide you with personalized
        feedback, and to perform research on improving those personalised
        feedback mechanisms for conceptual modelling education. The following
        personal data will be processed: [first name, last name, email, company
        (if provided), account type, link to your registration account,
        developed artefacts, activity logs]. KU Leuven will take all appropriate
        security measures to protect your personal data and will not transfer
        these data to any other Parties. KU Leuven will not keep your data any
        longer than necessary for the purposes identified in this paragraph,
        with a maximum of 5 years after your last use of the MERLIN Web
        Application. For any further information on KU Leuven’s processing of
        your personal data or to exercise your rights under the General Data
        Protection Regulation, please contact MERLIN@KULEUVEN.BE.
      </p>

      <h4>Article 8 - Warranty</h4>

      <p>
        8.1 The MERLIN Web Application is provided "as is" by KU LEUVEN without
        warranty of any kind, whether express or implied. KU LEUVEN specifically
        disclaims the implied warranties of merchantability and fitness for a
        particular purpose or that the use of the MERLIN Web Application will
        not infringe any patents, copyrights or trademarks or other rights of
        third parties. The entire risk as to the quality and performance of the
        MERLIN Web Application is borne by you.
      </p>

      <p>
        8.2 Without prejudice to KU LEUVEN's liability for damages caused by KU
        LEUVEN's willful misconduct, KU LEUVEN shall not be liable for any loss,
        direct or indirect damage or other liability incurred by you or any
        third party in connection with the MERLIN Web Application licensed by KU
        LEUVEN under this Agreement. Under no circumstances shall KU LEUVEN be
        liable for any direct, indirect, special, incidental, or consequential
        damages arising out of any performance of this Agreement, whether such
        damages are based on contract, tort or any other legal theory.
      </p>

      <h4>Article 9 - Indemnification</h4>

      <p>
        10.1 This Agreement is effective from the Effective Date until you stop
        using the MERLIN Web Application. This Agreement will terminate
        immediately without notice from KU LEUVEN if you fail to comply with any
        provision of this Agreement.
      </p>

      <p>
        10.2 In case of termination the provisions of Article 3, 4, 8 and 9
        shall remain in full force and effect.
      </p>

      <h4>Article 11 - Miscellaneous</h4>

      <p>
        11.1 Any notice authorized or required to be given to KU LEUVEN under
        this Agreement shall be in writing and shall be deemed to be duly given
        if sent by registered post to: Monique Snoeck, Faculty of Economics and
        Business, Naamsestraat 69, 3000 Leuven.
      </p>

      <p>
        11.2 The terms and conditions herein contained constitute the entire
        agreement between the Parties and supersede all previous agreements and
        understandings, whether oral or written, between the parties hereto with
        respect to the subject matter thereof.
      </p>

      <h4>Article 12 - Disputes</h4>

      <p>
        In the event of disputes in the interpretation and/or performance of
        this Agreement, the parties shall first undertake to settle their
        differences amicably. If no amicable settlement can be reached
        concerning the execution and/or interpretation of this Agreement, such
        conflict shall be brought before the courts of Leuven and Belgian Law
        shall be applicable.
      </p>
    </div>
  );
};

export default TermsAndConditions;
